import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "empty-value-display" }


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyValueDisplay',
  setup(__props) {

/* eslint-env vue/setup-compiler-macros */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, "—"))
}
}

})